module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"cart":"Carrinho","title":"Sua compra","cancel":"Esvaziar carrinho","description":"Veja como está seu carrinho até o momento.","email":"E-mail","keep-purchasing":"Continuar comprando","next":"Finalizar","total":"Quantidade de fotos"}}')
  delete Component.options._Ctor
}
